export default "__VITE_ASSET__Bkq4cJ49__"